import { TicketLineDTO, Permission, TicketLineStatus } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import * as SalesStore from '../SalesStore';
import getCancellationReason from './getCancellationReason';

function getActionToRemove(line: TicketLineDTO): [Permission, (reason: string) => Promise<void>] {

	const prepared = line.Status !== TicketLineStatus.New;
	const printed = line.HasBeenPrinted;

	if (!prepared && !printed)
		return [Permission.Ticket_RemoveLine, _ => SalesStore.removeLine(line)];

	if (!prepared && printed)
		return [Permission.Ticket_RemovePrintedLine, reason => SalesStore.removePrintedLine(line, reason)];

	if (prepared && !printed)
		return [Permission.Ticket_CancelLine, (reason: string) => SalesStore.cancelLine(line, reason)];

	if (prepared && printed)
		return [Permission.Ticket_CancelPrintedLine, reason => SalesStore.cancelPrintedLine(line, reason)];

	throw new Error('No se puede obtener la acción necesaria para eliminar la línea');
}

function userHasPermission(permission: Permission): boolean {
	return Preconditions.ensure(permission)();
}

declare global {
	interface CommandType {
		removeTicketLine: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('removeTicketLine', 'NO_PRECONDITION', async (line: TicketLineDTO): Promise<Result> => {

	const [permission, action] = getActionToRemove(line);

	if (!userHasPermission(permission))
		return Result.error();

	const result = await getCancellationReason(line);
	if (result.ok) {
		await action(result.value);
		await CustomerDisplay.displayRemovedLine(SalesStore.getTicket(), line);
	}

	return Result.ok();
});
